import { ElementType, ReactNode } from 'react'
import type { Polymorphic } from 'utilities/TypeUtils'
import { cn } from 'utilities/StringUtils'

type Types = 'caption' | 'caption2' | 'headline' | 'label' | 'title1' | 'title2' | 'title3'

interface Props {
  children: ReactNode
  className?: string
  type?: Types
  variant?: 'default' | 'success' | 'warning' | 'danger' | 'info'
}

export function Text<T extends ElementType = 'span'>({
  as: Component = 'span' as T,
  type,
  className,
  variant,
  children,
  ...props
}: Polymorphic<T, Props>): ReactNode {
  let classNames = ['block']

  switch (type) {
    case 'title1':
      classNames.push('text-4xl font-semibold')
      break
    case 'title2':
      classNames.push('text-3xl font-semibold')
      break
    case 'title3':
      classNames.push('text-xl font-semibold')
      break
    case 'headline':
      classNames.push('font-semibold text-lg')
      break
    case 'caption':
      classNames.push('text-sm')
      break
    case 'caption2':
      classNames.push('text-xs')
      break
    case 'label':
      classNames.push('text-sm font-medium dark:text-white ')
      break
    default:
      classNames.push('text-md')
  }

  switch (variant) {
    case 'success':
      classNames.push('text-green-600')
      break

    case 'warning':
      classNames.push('text-yellow-600')
      break

    case 'danger':
      classNames.push('text-red-600')
      break

    case 'info':
      classNames.push('text-blue-600')
      break

    default:
      switch (type) {
        case 'caption':
          classNames.push('text-muted-foreground')
          break

        case 'caption2':
          classNames.push('text-muted-foreground/80')
          break

        case 'label':
          classNames.push('text-gray-700')
      }
  }

  return (
    <Component {...(props as any)} className={cn(...classNames, className)}>
      {children}
    </Component>
  )
}
